import { type FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { graphql, createFragmentContainer } from 'react-relay/legacy';
import { type PdpSharedDetailShipsFrom_item$data } from './__generated__/PdpSharedDetailShipsFrom_item.graphql';
import { useAppSelector } from '../hooks/useReactReduxHooks';
// styles
import classnames from 'classnames';
import styles from '../shared/PdpSharedDetail/PdpSharedDetail.scss';
import dibsCss from 'dibs-css';

type Props = {
    item: PdpSharedDetailShipsFrom_item$data;
};

const PdpSharedDetailShipsFromComponent: FC<Props> = props => {
    const itemAddress = props?.item?.address?.itemAddress;

    const { isPDPDesktopAggregationVariant } = useAppSelector(
        ({ relayVariables }) => relayVariables?.variables || {}
    );

    const itemAddressElement = (
        <span
            className={classnames({
                [dibsCss.sassyFontBody]: !isPDPDesktopAggregationVariant,
                [dibsCss.sassyFontBodySmall]: isPDPDesktopAggregationVariant,
            })}
        >
            {itemAddress}
        </span>
    );

    return itemAddress ? (
        <div className={classnames(styles.shipsFromDetail, dibsCss.mtXsmall)}>
            <span
                className={classnames({
                    [dibsCss.sassyFontBodyTypeHeavy]: !isPDPDesktopAggregationVariant,
                    [dibsCss.sassyFontBodySmallHeavy]: isPDPDesktopAggregationVariant,
                })}
            >
                <FormattedMessage
                    id="pdp.pdpShippingDetails.shipsFrom"
                    defaultMessage="Shipping from: {itemAddressElement}"
                    values={{ itemAddressElement }}
                />
            </span>
        </div>
    ) : null;
};

export const PdpSharedDetailShipsFrom = createFragmentContainer(PdpSharedDetailShipsFromComponent, {
    item: graphql`
        fragment PdpSharedDetailShipsFrom_item on Item {
            address {
                itemAddress: displayCityStateCountry(fullCountryName: true)
            }
        }
    `,
});
